@if (isOpen()) {
<div class="fixed inset-0 z-50 overflow-y-auto">
  <div
    class="fixed inset-0 bg-white/70 backdrop-blur-sm"
    (click)="close()"
    aria-hidden="true"
  ></div>

  <div
    class="relative flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"
  >
    <span class="hidden sm:inline-block sm:h-screen sm:align-middle"
      >&#8203;</span
    >

    <div
      class="inline-block w-full transform rounded-lg border border-gray-200 bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:max-w-lg sm:align-middle"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-payment-title"
    >
      <!-- Modal Header -->
      <div class="rounded-t-lg bg-slate-600 px-4 pb-3 pt-5 sm:px-6 sm:pt-4">
        <div class="flex items-center justify-between">
          <h3
            id="add-payment-title"
            class="text-lg font-semibold text-slate-100"
          >
            Payment
          </h3>
          <lib-close-icon-button
            size="sm"
            variant="modal"
            colorScheme="dark"
            title="Close"
            ariaLabel="Close add payment modal"
            (clicked)="close()"
          />
        </div>
      </div>

      <!-- Balance Due Summary Banner -->
      <div class="border-b border-orange-100 bg-orange-50 px-4 py-3 sm:px-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="text-xs font-medium uppercase tracking-wide text-orange-600"
              >Balance Due</span
            >
          </div>
          <span class="text-xl font-bold text-orange-700">
            {{ remainingAmountMajor() | number : '1.2-2' }}
            <span class="text-base font-semibold text-orange-500">{{
              currency()
            }}</span>
          </span>
        </div>
      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="flex flex-col gap-y-5 px-4 pb-4 pt-5 sm:px-6"
      >
        <!-- Amount Row -->
        <div class="flex flex-col gap-y-1">
          <label
            for="amount"
            class="text-xs font-semibold uppercase tracking-wide text-gray-500"
          >
            Amount <span class="text-red-500">*</span>
          </label>
          <div class="relative flex rounded-md shadow-sm">
            <span
              class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-sm font-medium text-gray-600"
            >
              {{ currency() }}
            </span>
            <input
              id="amount"
              type="number"
              step="0.01"
              min="0.01"
              formControlName="amount"
              class="block w-full rounded-r-md border border-gray-300 px-3 py-2.5 text-sm shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
              placeholder="0.00"
              autocomplete="off"
            />
          </div>
          @if (submitted() && form.get('amount')?.errors?.['required']) {
          <p class="text-xs text-red-600">Amount is required</p>
          } @if ((submitted() || form.get('amount')?.touched) &&
          form.get('amount')?.errors?.['max']) {
          <p class="text-xs text-red-600">
            Amount cannot exceed balance due of
            {{ remainingAmountMajor() | number : '1.2-2' }} {{ currency() }}
          </p>
          }
        </div>

        <!-- Date and Method Row -->
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col gap-y-1">
            <label
              for="payment_date"
              class="text-xs font-semibold uppercase tracking-wide text-gray-500"
            >
              Payment Date <span class="text-red-500">*</span>
            </label>
            <input
              id="payment_date"
              type="date"
              formControlName="payment_date"
              class="block w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
            />
            @if (submitted() && form.get('payment_date')?.errors?.['required'])
            {
            <p class="text-xs text-red-600">Payment date is required</p>
            }
          </div>

          <div class="flex flex-col gap-y-1">
            <label
              for="payment_method"
              class="text-xs font-semibold uppercase tracking-wide text-gray-500"
            >
              Payment Method <span class="text-red-500">*</span>
            </label>
            <select
              id="payment_method"
              formControlName="payment_method"
              class="block w-full rounded-md border border-gray-300 bg-white px-3 py-2.5 text-sm shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
            >
              @for (method of paymentMethods; track method.value) {
              <option [value]="method.value">{{ method.label }}</option>
              }
            </select>
          </div>
        </div>

        <!-- Reference -->
        <div class="flex flex-col gap-y-1">
          <label
            for="payment_reference"
            class="text-xs font-semibold uppercase tracking-wide text-gray-500"
          >
            Reference / Memo <span class="text-red-500">*</span>
          </label>
          <input
            id="payment_reference"
            type="text"
            formControlName="payment_reference"
            class="block w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
            placeholder="e.g. TXN-12345"
          />
          @if (submitted() &&
          form.get('payment_reference')?.errors?.['required']) {
          <p class="text-xs text-red-600">Reference is required</p>
          }
        </div>

        <!-- Notes -->
        <div class="flex flex-col gap-y-1">
          <label
            for="payment_notes"
            class="text-xs font-semibold uppercase tracking-wide text-gray-500"
          >
            Notes
            <span
              class="ml-1 text-xs font-normal normal-case tracking-normal text-gray-400"
              >(optional)</span
            >
          </label>
          <textarea
            id="payment_notes"
            formControlName="notes"
            rows="2"
            class="block w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm shadow-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
            placeholder="Additional notes about this payment"
          ></textarea>
        </div>

        <!-- Actions -->
        <div class="flex justify-end gap-3 border-t border-gray-100 pt-4">
          <shared-submit-button buttonText="Save" />
          <shared-cancel-button text="Cancel" (cancelled)="close()" />
        </div>
      </form>
    </div>
  </div>
</div>
}
